import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { getTicketBySlug } from "../data/tickets";
import { buildGeneralWhatsAppUrl, buildTicketWhatsAppUrl } from "../lib/whatsapp";

export function FloatingWhatsApp() {
  const { pathname } = useLocation();
  const ticketSlug = pathname.match(/^\/tickets\/([^/]+)$/)?.[1];
  const ticket = ticketSlug ? getTicketBySlug(ticketSlug) : undefined;
  const href = ticket
    ? buildTicketWhatsAppUrl(ticket)
    : buildGeneralWhatsAppUrl(pathname === "/contact" ? "Ticket, group, VIP hospitality or yacht enquiry" : "Race-weekend package enquiry");

  return (
    <a
      className="floating-whatsapp"
      href={href}
      data-whatsapp-location="floating"
      data-whatsapp-package-id={ticket?.id}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with RP Abu Dhabi GP on WhatsApp"
    >
      <MessageCircle aria-hidden="true" />
      <span>WhatsApp</span>
    </a>
  );
}
